export default __webpack_public_path__ + "static/media/mask_icon_white_desk.d83081ec.png";